import React, { useEffect } from "react";
import { RouterProvider } from "react-router";
import "./App.css";

import router from "@views/Routes";
import { FirebaseAuthProvider } from "@/contexts/UserProfileContext/UserProfileContext";
import { StudiesHooksProvider } from "@/hooks";
import ErrorHandler from "./components/ErrorHandler";
import useGlobalExternalLinkHandler from "./utils/globalExternalLinkHandler";
import AntDesignConfig from "./antDesignConfig";
import {
    listenForIframeModalOffset,
    listenForIframeParentWindowResize,
    syncIframeDocumentState,
} from "./utils/iframeUtils";

function App() {
    // Warn users when they are navigating away from the app
    const redirectPopup = useGlobalExternalLinkHandler();

    useEffect(() => {
        syncIframeDocumentState();
        const stopListeningForIframeModalOffset = listenForIframeModalOffset();
        const stopListeningForIframeParentWindowResize = listenForIframeParentWindowResize();

        return () => {
            stopListeningForIframeModalOffset();
            stopListeningForIframeParentWindowResize();
        };
    }, []);

    return (
        <>
            {redirectPopup}
            <ErrorHandler>
                <FirebaseAuthProvider>
                    <StudiesHooksProvider>
                        <AntDesignConfig>
                            <RouterProvider router={router} />
                        </AntDesignConfig>
                    </StudiesHooksProvider>
                </FirebaseAuthProvider>
            </ErrorHandler>
        </>
    );
}

export default App;
